<template>
	<div>
		<div class="hero-wrapper">
			<div class="hero">
				<b-container>
					<div class="hero-inner">
						<h2 class="large">404</h2>
						<h1 class="display-1">
							Sorry, it seems we’ve taken a wrong turn.
							<span class="subtitle">Try searching for a city, a specific hotel, or even a landmark!</span>
						</h1>
						<Search :search="search" />
						<Partners/>
					</div>
				</b-container>
			</div>
		</div>
	</div>
</template>

<script>
import dayjs from 'dayjs'

import Search from '@/components/ui/Search.vue'
import Partners from '@/components/ui/Partners.vue'

export default {
	components: {
		Search,
		Partners
	},
   data () {
		return {
			blogs: null,
			search: {
				place: {
					name: '',
					lat: '',
					lng: '',
				},
				date: {
					checkin: dayjs().format('YYYY-MM-DD'),
					checkout: dayjs().add(1, 'day').format('YYYY-MM-DD'),
				},
				occupation: {
					adults: 2,
					rooms: 1,
					children: 0,
					ages: [],
				},
				sort: 'recommended',
        currency: (this.$route.query.currency ? this.$route.query.currency : 'EUR'),
			},
			results: [],
		}
	},
}
</script>

<style scoped>
  .large{
    font-size:4rem;
    line-height:4.5rem;
  }
  .subtitle{
    font-size:16px;
    display:block;
    margin-top:10px;
    margin-bottom:15px;
    font-weight:normal;
  }
   .hero{
    min-height:450px;
    position:relative;
    padding:15px;
    color:#fff;
  }
  .hero::before{
    content:"";
    position:absolute;
    top:0;
    right:0;
    bottom:0;
    left:0;
    background-image: url('../assets/bg.jpg');
    background-size:cover;
    background-position:50% 50%;
    background-attachment:fixed;
    opacity:1;
    z-index:-3;
  }
  .hero::after{
    content:"";
    position:absolute;
    background-color:rgb(0,0,0);
    opacity:0.5;
    top:0;
    right:0;
    bottom:0;
    left:0;
    z-index:-2;
  }
  .hero-inner{
    margin-top:50px;
  }
</style>
